import React, { FC, useEffect, useLayoutEffect, useState } from "react";
import { CircularProgress, Typography } from "@mui/material";
import { useLazyGetPingQuery } from "../../../../business.InterfaceLayer/store/entities/ping.entity/redux/api";
import HTTP_STATUSES from "../../../../general/constants/http/httpStatuses";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { routeBuilder } from "../../../router/services/routeBuilder.service";
import RoutesPaths from "../../../router/routePath";
import CabinetRoutesPaths from "../../../router/routes/cabinet.route/cabinet.routesPaths";

const InternalServerErrorPage: FC = () => {
	const [requestGetPing, { error, data, isSuccess }] = useLazyGetPingQuery();
	const [intervalTime, setIntervalTime] = useState(1500); // начальный интервал в 30 секунд
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [isViewErrorWindow, setIsViewErrorWindow] = useState(false);

	useEffect(() => {
		const handlePing = () => {
			requestGetPing({});
			// Увеличиваем интервал до 1 минуты после первого запроса
			setIntervalTime(3000);
		};

		// Вызываем функцию handlePing сначала сразу, а затем повторяем через заданный интервал
		const intervalId = setInterval(handlePing, intervalTime);

		// Очистка интервала при размонтировании компонента
		return () => clearInterval(intervalId);
	}, [requestGetPing, intervalTime, error, data, navigate]);

	useLayoutEffect(() => {
		requestGetPing({});
	}, [requestGetPing]);

	const isNeedRedirect =
		error || isSuccess
			? error?.status !== HTTP_STATUSES.INTERNAL_SERVER_ERROR &&
			  error?.status !== HTTP_STATUSES.CORS
			: false;

	useEffect(() => {
		if (isSuccess || error) {
			setIsViewErrorWindow(true);
		}
		// Проверяем статус ответа
		if (isNeedRedirect) {
			navigate(routeBuilder([RoutesPaths.CABINET, CabinetRoutesPaths.MAIN]));
			return;
		}
	}, [error, navigate, isSuccess]);

	return isViewErrorWindow ? (
		<div
			style={{
				minHeight: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				backgroundSize: "cover",
				backgroundPosition: "center",
			}}
		>
			<div style={{ textAlign: "center" }}>
				<div>
					<img
						alt={"Логотип"}
						src={"/lk/favicon/icon-192x192.png"}
					/>
				</div>
				<div style={{ marginTop: "65px", color: "black" }}>
					<CircularProgress />
				</div>
				<Typography
					variant="h4"
					sx={{
						color: "text.primary",
						display: "block",
						textAlign: "center",
						marginTop: "15px",
						marginBottom: "15px",
					}}
				>
					{t("text_m_269")}
				</Typography>

				<Typography
					variant="body1"
					sx={{
						color: "text.primary",
						display: "block",
						textAlign: "center",
						maxWidth: "404px",
						margin: "auto",
					}}
				>
					{t("text_m_270")}
				</Typography>
			</div>
		</div>
	) : null;
};

export default InternalServerErrorPage;
